var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "e-accordions__accordion" }, [
    _c(
      "button",
      {
        staticClass: "e-accordions__accordion-button",
        class: { "accordion-open": _vm.open },
        attrs: { "aria-expanded": "open" },
        on: {
          click: function ($event) {
            return _vm.toggleOpen()
          },
        },
      },
      [
        _vm.icon !== ""
          ? _c("div", { staticClass: "e-accordions__accordion-icon" }, [
              _c("img", {
                attrs: { src: _vm.icon, width: "25px", height: "25px" },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "e-accordions__accordion-title h3" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "e-accordions__chevron" }),
      ]
    ),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.open,
          expression: "open",
        },
      ],
      staticClass: "e-accordions__accordion-content typography",
      attrs: { "aria-hidden": !_vm.open },
      domProps: { innerHTML: _vm._s(_vm.expandedContent) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }